import { render, staticRenderFns } from "./DuplicateBundle.vue?vue&type=template&id=a60d7a98&"
import script from "./DuplicateBundle.vue?vue&type=script&lang=js&"
export * from "./DuplicateBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports